import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { APP_ROUTES, ids } from 'apps/web_forms/utils/constants';
import { fetchFormList, setSelectedForm } from 'apps/web_forms/slices/appSlice';
import FormList from 'apps/web_forms/components/FormList';
import FormListElement from 'apps/web_forms/components/FormListElement';
import useGlobalSelector from 'apps/web_forms/hooks/useGlobalSelector';

const Forms = () => {
  const [forms, setForms] = useState([]);
  const history = useHistory();
  const { formList } = useGlobalSelector();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchFormList());
  }, []);

  useEffect(() => {
    if (formList.data) setForms(formList.data);

    if (formList.error) history.push(APP_ROUTES.getErrorPageByCode(500));
  }, [formList]);

  const goToForm = (id, version) => {
    const selectedForm = formList.data.find((form) => parseInt(form.identifier) === parseInt(id));
    dispatch(setSelectedForm(selectedForm));
    history.push(APP_ROUTES.getFormPageById(id));
  };

  return (
    <>
      <FormList
        id={ids.FormsIds.MainFormList}
        header
        title='Forms'
        description='Online Forms allows you to submit forms directly from a browser with out
          needing your device. Below is a list of all forms associated with your
          user.'
        loading={formList.loading}
        forms={forms}
        searchBarSticky
      >
        {(form, index) => (
          <FormListElement
            index={index}
            key={form.identifier}
            identifier={form.identifier}
            title={form.title}
            description={form.description}
            onClick={(formId) => goToForm(formId, form.version)}
          />
        )}
      </FormList>
    </>
  );
};

export default Forms;
